export default __webpack_public_path__ + "static/media/flesh3.785bd7c5.png";